import React from 'react';

const Vue_Syllabus = () => {
  return (
    <div>
      <h1>Vue_Syllabus Component</h1>
      <p>This is the Vue_Syllabus tutorial page.</p>
    </div>
  );
}

export default Vue_Syllabus;
